/**
 * please fill this file and coreComponents.ts
 */

export const coreComponentsMapping = {
    Audience: 'Audience',
    Avatar: 'Avatar',
    AddReportModal: 'AddReportModal',
    CommentsBloc: 'CommentsBloc',
    DisplayForm: 'DisplayForm',
    EditorsPortal: 'EditorsPortal',
    Editor: 'Editor',
    Empty: 'Empty',
    FullPageLayout: 'FullPageLayout',
    InputTinyMCEWithExtRaw: 'JRCInputTinyMCEWithExtRaw',
    InputTinyMCEWithExt: 'JRCInputTinyMCEWithExt',
    ModalAudience: 'ModalAudience',
    TinyMCEAIModal: 'AIModal',
    TinyMCEMarkdownModal: 'MarkdownModal',
    TwoColLayout: 'TwoColLayout',
    WidgetWrapperCore: 'WidgetWrapperCore',
    WidgetList: 'WidgetList',
} as const;

/**
 * please fill this file and coreComponents.ts
 */
